import { useLocation } from 'react-router-dom';
import { usePeriod } from '../context/PeriodContext';
import { useLocationScope } from '../context/LocationContext';
import { useMediaQuery } from '../hooks/useMediaQuery';
import { formatPeriod } from '../format';
import { LocationPicker, LOCATION_ROUTES } from './LocationPicker';
import { PeriodPicker } from './PeriodPicker';

export function ScopePicker() {
  const mobile = useMediaQuery('(max-width: 900px)');
  const { period } = usePeriod();
  const { locations, locationId } = useLocationScope();
  const { pathname } = useLocation();
  if (!mobile) return <><LocationPicker /><PeriodPicker /></>;
  const local = locations.find((item) => item.locationId === locationId)?.name ?? 'Todos los locales';
  return <details className="scope-picker" key={pathname}>
    <summary><span><strong>{formatPeriod(period.start, period.end)}</strong>{LOCATION_ROUTES.has(pathname) && locations.length > 1 && <small>{local}</small>}</span><span className="scope-picker__action">Filtros ⌄</span></summary>
    <div className="scope-picker__fields"><LocationPicker /><PeriodPicker /></div>
  </details>;
}
